$(document).ready(function () {
  // your code
  var window = $(window);
  $("[data-toggle='popover']").popover();
  $('[data-toggle="tooltip"]').tooltip()
  $(".select2").select2();

  $("#menuBtn").click(function () {
    $("#menuItem").toggleClass("menu-open");
  });
  // Mobile Close
  $("#menuBtnClose").click(function () {
    $("#menuItem").removeClass("menu-open");
  });

  // Wizard
  $(".wizard-next").click(function () { // wizard next
    var current = $(".wizard-list li.active");
    if ($(current).next('li').length) {
      $(current).removeClass("active").next().addClass("active");
    }
  });
  $(".wizard-prev").click(function () { // wizard prev
    var current = $(".wizard-list li.active");
    if ($(current).prev('li').length) {
      $(current).removeClass("active").prev().addClass("active");
    }
  })
})